module.exports = __webpack_public_path__ + "static/media/edit.c6837c5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/edit.svg
// module id = 142
// module chunks = 0